import ahoy from 'ahoy.js'
import { debounce } from '../utils/timeUtils'

const env = window.appData?.env
const isTrackingEnabled = env === 'production' || env === 'staging'

if (isTrackingEnabled) {
  ahoy.configure({
    urlPrefix: '',
    visitsUrl: '/ahoy/visits',
    eventsUrl: '/ahoy/events',
    visitDuration: 30,
    withCredentials: true,
    visitParams: {},
    useBeacon: true,
  })

  const significantFrames = ['main', 'content', 'modal']

  const trackPageView = debounce((url) => {
    ahoy.track('page_view', { url })
  }, 200)

  document.addEventListener('turbo:load', () => {
    trackPageView(window.location.pathname)
  })

  document.addEventListener('turbo:frame-load', (event) => {
    if (significantFrames.includes(event.target.id)) {
      const url = new URL(event.target.src || window.location.href).pathname
      trackPageView(url)
    }
  })

  // Dialog open tracking via Turbo Streams
  const dialogContainers = ['main_modal', 'main_offsetcanvas']

  document.addEventListener('turbo:before-stream-render', (event) => {
    const stream = event.target
    const target = stream.getAttribute('target')
    const action = stream.getAttribute('action')

    if (!dialogContainers.includes(target) || action !== 'update') return

    const template = stream.querySelector('template')
    const content = template?.content
    if (!content?.children.length) return

    const title =
      content.querySelector('.modal-title')?.textContent?.trim() ||
      content.querySelector('.modal-header h4, .modal-header h5')?.textContent?.trim() ||
      content.querySelector('.offcanvas-title')?.textContent?.trim() ||
      'unknown'

    ahoy.track('dialog_open', {
      container: target,
      title,
      url: window.location.pathname,
    })
  })
}

export { ahoy }
